// ── Backend V2 API ──────────────────────────────────────────
const BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";

function getToken() {
  return localStorage.getItem("accessToken") || "";
}

function authHeaders() {
  const token = getToken();
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

// ── Public ──────────────────────────────────────────────────

export async function fetchBlogs() {
  const response = await fetch(`${BASE}/api/blogs`);
  if (!response.ok) throw new Error("Failed to fetch blogs");
  const data = await response.json();
  return data.blog;
}

export async function fetchBlogsRandom() {
  const data = await fetchBlogs();
  return [...data].sort(() => 0.5 - Math.random()).slice(0, 3);
}

export async function fetchBlogsRandom5() {
  const data = await fetchBlogs();
  return [...data].sort(() => 0.5 - Math.random()).slice(0, 5);
}

export async function fetchBlogById(id) {
  const response = await fetch(`${BASE}/api/blogs/${id}`);
  if (!response.ok) throw new Error("Failed to fetch blog");
  const data = await response.json();
  return data.blog_by_pk;
}

// ── Admin (protected) ───────────────────────────────────────

export async function insertBlog(newBlog) {
  const response = await fetch(`${BASE}/api/blogs`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(newBlog),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || "Failed to insert blog");
  }
  return response.json();
}

export async function updateBlog(id, updatedBlog) {
  const response = await fetch(`${BASE}/api/blogs/${id}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(updatedBlog),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || "Failed to update blog");
  }
  return response.json();
}

export async function deleteBlog(id) {
  const response = await fetch(`${BASE}/api/blogs/${id}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error("Failed to delete blog");
}
